import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

const DeleteConfirmationModal = ({ open, onClose, onConfirm, loading }: any) => (
  <Dialog
    open={open}
    onClose={onClose}
  >
    <DialogTitle>Delete NPC entry?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        This removes the entry from your NPC log. This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button
        onClick={onClose}
        color="inherit"
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={loading}
      >
        {loading ? 'Deleting…' : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmationModal;
